/** Domain API del módulo Catálogo — tipos, funciones puras, constantes, error classes.
 * Cero dependencias en infra/app/ui. Importar desde acá para evitar require cycles. */

export type {
  ProductQueryParams,
  ProductSearchRow,
  ProductMutationOpts,
  ProductCatalogEventRow,
  ProductCatalogHistoryFilters,
  CatalogProductRow,
  CatalogFilter,
  CatalogSort,
  BulkPreviewItem,
} from './domain/catalogTypes';

export type { CategoryFilterState, CategoryMutationInput } from './domain/catalogCategoryTypes';
export type {
  CreateSupplierParams,
  SupplierFilterState,
  SupplierRecord,
  UpdateSupplierParams,
} from './domain/catalogSupplierTypes';
export type {
  BrandFilterState,
  BrandRecord,
  CreateBrandParams,
  UpdateBrandParams,
} from './domain/catalogBrandTypes';

export type { CatalogListPageSize } from './domain/catalogPaginationConstants';
export { CATALOG_ADMIN_PAGE_SIZE_STORAGE_KEY } from './domain/catalogPaginationConstants';
export { PAGE_SIZE, CATALOG_HISTORY_PAGE_SIZE } from './domain/catalogPaginationConstants';

export {
  CatalogBarcodeDuplicateError,
  CatalogDomainError,
  CatalogSkuDuplicateError,
  SupplierCodeDuplicateError,
  VariantInputValidationError,
} from './domain/catalogErrors';

export {
  ivaRateToTaxClass,
  resolveInsertIsActive,
  taxClassToIvaRate,
} from './domain/catalogProductDefaults';
export type { ProductIvaRate } from './domain/catalogProductDefaults';
export type { ProductVariant } from './domain/productVariants';

export { buildVariantGridLayout } from './domain/variantGridLayout';

export {
  productRequiresWeightInput,
  productRequiresHourInput,
  productRequiresQuantityInput,
  formatUnitLabel,
} from './domain/productVariants';

export { createCategoryDisplayResolver, formatProductCatalogEventSummary } from './domain/catalogEventSummary';
export { getProductCatalogEventTypeLabel } from './domain/catalogLabels';

export type {
  CatalogCsvEntityKind,
  CsvImportCommitResult,
  CsvImportPreviewResult,
  CsvImportPreviewRow,
  CsvImportRowStatus,
} from './domain/csv/csvEntityKinds';

export {
  isLegacyProductCategoryHint,
  productQueueErrorLooksStuck,
  remapLegacyProductCategoryId,
  remapProductSyncPayload,
} from './domain/legacyCategoryId';

export type {
  MenuModifierKind,
  MenuOptionGroup,
  MenuOptionChoice,
  SelectedMenuOption,
} from './domain/menuModifiers';
export {
  formatOptionsLabel,
  isMenuGroupFullyUnavailable,
  menuOptionsKey,
  noneChoiceLabel,
  shouldShowNoneChoiceRow,
  optionsPriceDelta,
  parseModifierKind,
  toSelectedMenuOption,
  unitPriceWithOptions,
  validateMenuSelection,
} from './domain/menuModifiers';

export type {
  CatalogItemTypeFilter,
  Product,
} from './domain/productTypes';

export type {
  ComboAvailability,
  ComboDraftComponent,
  ProductCombo,
  ProductComboComponent,
} from './domain/productCombos';
export {
  comboAvailability,
  groupProductComboRows,
  isComboProduct,
  isComboValidityOutOfWindow,
  parseComboDateInput,
  validateComboDraft,
} from './domain/productCombos';

export type {
  CategoryAppliesTo,
  CategoryRecord,
} from './domain/categoryTypes';

export {
  normalizeProductCategoryId,
  normalizeCategoryAppliesTo,
  categoryAppliesToDraftItemType,
  sqlCategoryComparableValuesForFilter,
  productMatchesCategoryFilter,
  getCategoryDisplayLabel,
} from './domain/categoryTypes';

export type {
  CategoryFilterOption,
  CategoryOption,
} from './domain/categoryOptions';

export {
  categoryAppliesToShortLabel,
  buildCategoryOptions,
  buildCategoryFilterOptions,
  buildCategoryOptionsWithFallback,
} from './domain/categoryOptions';

export type { ProductLookupResult, BarcodeLookupSource, BarcodeLookupSuggestion, RemoteBarcodeHit } from './domain/barcodeLookup';
export type { BarcodeLookupRemoteResult } from './domain/barcodeLookup';

export type { ProductDraft, ProductVariantDraft } from './domain/productDraft';
export { emptyDraft, emptyVariantDraft } from './domain/productDraft';
export { statusFilters, sortOptions } from './domain/catalogFilterOptions';

export { getCatalogProductStockSignal } from './domain/catalogProductStockSignal';
export { getProductCompletenessIssues, getProductCompletenessSummary } from './domain/catalogProductCompleteness';

export type {
  RemoteSnapshotStockRow,
  RemoteSnapshotStockTransferRow,
  RemoteSnapshotStockLotRow,
} from './domain/catalogSnapshotTypes';

export type { CatalogProductBranchStockView } from './domain/catalogTypes';
